module.exports = __webpack_public_path__ + "static/media/v.b29483c9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/v.mp3
// module id = 111
// module chunks = 0